const STORAGE_KEY = 'employer-review-path-tour-v1';

/** Scoped to browser profile — not shared across users on the same machine unless same profile. */
export function isEmployerReviewPathTourDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dismissed';
  } catch {
    return false;
  }
}

export function markEmployerReviewPathTourDismissed(): void {
  try {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
  } catch {
    // ignore quota / private mode
  }
}
